/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Dev_Backend_Prod_BodyInputs */

const en_mobile_dev_backend_prod_body = /** @type {(inputs: Mobile_Dev_Backend_Prod_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Production has real accounts and real data. Google and Apple sign-in do not work from a dev build — use email and password.`)
};

const es_mobile_dev_backend_prod_body = /** @type {(inputs: Mobile_Dev_Backend_Prod_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Producción tiene cuentas y datos reales. El inicio de sesión con Google y Apple no funciona desde una compilación de desarrollo; usa correo y contraseña.`)
};

/**
* | output |
* | --- |
* | "Production has real accounts and real data. Google and Apple sign-in do not work from a dev build — use email and password." |
*
* @param {Mobile_Dev_Backend_Prod_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_dev_backend_prod_body = /** @type {((inputs?: Mobile_Dev_Backend_Prod_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Dev_Backend_Prod_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_dev_backend_prod_body(inputs)
	return en_mobile_dev_backend_prod_body(inputs)
});